common.View.create('common.canvas.blocks.custom.accordion.Block', {

    onDOMLoad() {
        this.initAccordion();
    },

    initAccordion()
    {
        this.element.find('[data-toggle][data-target]')
            .on('click', (event) => {
                // Is already visible?
                let isVisible = $(event.currentTarget).find('+ *').is(':visible');

                // Slide down all accordion items
                $(event.currentTarget).parents('.accordion')
                    .find('.accordion-item')
                        .find('.icon')
                            .removeClass('tw-transform tw-rotate-45')
                            .end()
                        .find('+ *')
                            .slideUp('fast')
                            .end()
                        .end();

                // Was visible?
                if( isVisible ) {
                    return;
                }

                // Slide down current slide
                $(event.currentTarget)
                    .find('.icon')
                        .toggleClass('tw-transform tw-rotate-45')
                        .end()
                    .next()
                    .slideDown('fast');
            });
    }
});
